<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <a-form
    class="form form-search"
    layout="inline"
    :model="modelRef"
    @finish="onFinish"
    @finishFailed="onFinishFailed"
  >
    <a-form-item label="备份周期" name="cycle">
      <a-select
        placeholder="请选择"
        dropdownClassName="search-select-dropdown"
        v-model:value="modelRef.cycle"
      >
        <a-select-option value="每周一">每周一</a-select-option>
        <a-select-option value="每周一">每周二</a-select-option>
      </a-select></a-form-item
    >

    <a-form-item label="备份时间" name="time">
      <a-time-picker placeholder="请选择" v-model:value="modelRef.time" />
    </a-form-item>

    <a-form-item label="备份状态" name="status">
      <a-select
        placeholder="请选择"
        dropdownClassName="search-select-dropdown"
        v-model:value="modelRef.status"
      >
        <a-select-option value="开启">开启</a-select-option>
        <a-select-option value="关闭">关闭</a-select-option>
      </a-select></a-form-item
    >

    <div class="btns">
      <a-button class="button-primary" @click="onFinish">查询</a-button>
      <a-button class="m-l button-base" @click="reset">重置</a-button>
    </div>
  </a-form>
</template>

<script>
import { reactive, toRaw } from "vue";
import { Form, Input, Select, Button, TimePicker, Row, Col } from "ant-design-vue";
const FormItem = Form.Item;
const useForm = Form.useForm;

export default {
  name: "plan-search",
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [TimePicker.name]: TimePicker,
    [Button.name]: Button,
    [Select.name]: Select,
    [Row.name]: Row,
    [Col.name]: Col,
    ASelectOption: Select.Option
  },
  emits: ["onGetList"],
  setup(props, context) {
    const modelRef = reactive({
      time: null,
      cycle: undefined,
      status: undefined
    });
    const searchList = reactive([
      {
        name: "time"
      },
      {
        name: "cycle"
      },
      {
        name: "status"
      }
    ]);

    const getValues = () => {
      const values = toRaw(modelRef);
      if (values.time) values.time.format("hh-mm-ss");
      return values;
    };

    const { resetFields } = useForm(modelRef);
    const onFinish = () => {
      const values = getValues();
      context.emit("onGetList", values);
    };

    const onFinishFailed = (errorInfo) => {
      console.log("Failed:", errorInfo);
    };

    const reset = () => {
      resetFields();
      context.emit("onGetList", {});
    };

    const formItemLayout = {
      wrapperCol: {
        span: 24
      }
    };

    return {
      modelRef,
      onFinish,
      onFinishFailed,
      reset,
      getValues,
      searchList,
      formItemLayout
    };
  }
};
</script>

//
<style lang="less" scoped>
// .ant-form-item {
//   margin-right: 32px !important;
//   margin-bottom: 24px !important;
//   text-align: left;
// }
// .ant-form-inline {
//   display: block;
// }
//
</style>
